import React from "react";
import { useNavigate } from "react-router-dom"; // ADAUGĂ ACEST IMPORT
import whatsappIcon from "../assets/whatsapp.png";
import contactIcon from "../assets/contact.png";

const Footer = () => {
  const navigate = useNavigate(); // ADAUGĂ ACEST HOOK

  return (
    <footer className="bg-[#025951] text-white flex flex-col sm:flex-row items-center justify-between px-6 py-4 w-full shadow-2xl border-t border-emerald-400/20 dark:border-neutral-500">
      <div className="text-center sm:text-left">
        <p className="text-lg font-semibold">We are available</p>
        <p className="text-sm opacity-90">Monday – Friday 9AM to 5PM</p>
      </div>
      <div className="flex gap-6 mt-3 sm:mt-0">
        {/* WhatsApp cu mesaj pre-completat */}
        <a
          href="https://wa.me/447305959777?text=Hello%2C%20I%20would%20like%20to%20inquire%20about%20your%20dental%20services."
          target="_blank"
          rel="noopener noreferrer"
          aria-label="WhatsApp"
          className="hover:scale-110 transition-transform duration-200 p-2 rounded-full hover:bg-white/10"
        >
          <img
            src={whatsappIcon}
            alt="WhatsApp"
            className="w-8 h-8 sm:w-10 sm:h-10"
          />
        </a>
        
        {/* Contact - navighează la contact-us și scroll la început */}
<button 
  onClick={() => {
    navigate('/contact-us');
    window.scrollTo(0, 0); // Scroll la început de pagină
  }}
  aria-label="Contact"
  className="hover:scale-110 transition-transform duration-200 p-2 rounded-full hover:bg-white/10 bg-transparent border-none"
>
  <img
    src={contactIcon}
    alt="Contact"
    className="w-8 h-8 sm:w-10 sm:h-10"
  />
</button>
      </div>
    </footer>
  );
};

export default Footer;